import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IServerSettingsUnauthenticated } from '../../../settings/types/IServerSettingsUnauthenticated';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetServerSettingsUnauthenticatedParams {
}

export interface IGetServerSettingsUnauthenticatedResult extends IResult, IServerSettingsUnauthenticated {
}

export class GetServerSettingsUnauthenticatedRequest
    extends Request<IGetServerSettingsUnauthenticatedParams, IGetServerSettingsUnauthenticatedResult> {
  constructor(params: IGetServerSettingsUnauthenticatedParams = {}) {
    super('getServerSettingsUnauthenticated', params);
  }
}
